/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".save-btn[_ngcontent-%COMP%]{line-height:16px;padding:2px 12px;border-radius:2px;font-size:13px}"];
export { styles as styles };
